import '../../../base/outline-grid/outline-column/outline-column';
import '../../../base/outline-grid/outline-grid';
import '../../ghs-button/ghs-button';
import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement, state } from 'lit/decorators.js';
import componentStyles from './ghs-location-detail-left-column.css.lit';
import { SlotController } from '../../../controllers/slot-controller';

/**
 * The GhsLocationDetailLeftColumn component
 *
 * The interactive map generator Leaflet does not work with the slotted controller, however the slotted controller is necessary for other aspects of <ghs-location-detail> to function properly. The solution is to break those out into this sub-component.
 * @element ghs-location-detail-left-column
 */
@customElement('ghs-location-detail-left-column')
export class GhsLocationDetailLeftColumn extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  slots = new SlotController(this, true);

  @state() hasLocationIdentifiers: boolean;
  @state() hasLocationAddress: boolean;
  @state() hasLocationHeader: boolean;
  @state() hasLocationDetails: boolean;
  @state() hasLocationCTA: boolean;

  firstUpdated(): void {
    super.firstUpdated();
    this.hasLocationIdentifiers = this.slots.test('location-identifiers');
    this.hasLocationHeader = this.slots.test('location-header');
    this.hasLocationAddress = this.slots.test('location-address');
    this.hasLocationDetails = this.slots.test('location-details');
    this.hasLocationCTA = this.slots.test('location-cta');
  }

  render(): TemplateResult {
    return html`
      <div class="location-detail-left__left-column">
        ${this.hasLocationIdentifiers
          ? html`<div class="location-detail-left__identifiers">
              <slot name="location-identifiers"></slot>
            </div>`
          : nothing}
        ${this.hasLocationHeader
          ? html` <h3 class="location-detail-left__header">
              <slot name="location-header"></slot>
            </h3>`
          : nothing}
        ${this.hasLocationAddress
          ? html`<address class="location-detail-left__address">
              <slot name="location-address"></slot>
            </address>`
          : nothing}
        ${this.hasLocationDetails
          ? html`<slot name="location-details"></slot>`
          : nothing}
        ${this.hasLocationCTA
          ? html` <slot name="location-cta"></slot>`
          : nothing}
      </div>
    `;
  }
}
